export enum VestingMode {
  OPTIONS = 'OPTIONS',
  FREE_SHARES = 'FREE_SHARES'
}
